import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export class GuidanceStepRouteConfig extends CurrentEstateRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    return !!(
      getters.auth.getUser()?.permission.canAccessGuidanceSteps &&
      getters.auth.getUser()?.permission.canAccessStandardPlanGuidanceSteps
    );
  }
}
